import React, { useEffect, useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useSelector } from "react-redux";
import Select, { components } from "react-select";
import { postShortCode } from "../../../connections/postShortCode";
import { useQuery } from "@tanstack/react-query";
import { getMedicalTest } from "../../../connections/getMedicalTest";
import useDebounce from "../../../utils/hooks";
import { Search } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import CreatableSelect from "react-select/creatable";
import { getLabsList } from "../../../connections/getLabsList";

const AddShortCode = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const [formState, setFormState] = useState({});
  const [medicalTestRows, setMedicalTestRows] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const navigate = useNavigate();
  const handleChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle adding new medical test row
  const handleAddMedicalTestRow = (e) => {
    e.preventDefault();
    setMedicalTestRows((prev) => [
      ...prev,
      {
        medical_test_id: null,
        lab: null,
      },
    ]);
  };

  // Handle removing medical test row
  const handleRemoveMedicalTestRow = (e, idx) => {
    e.preventDefault();
    const updatedRows = medicalTestRows.filter((_, index) => index !== idx);
    setMedicalTestRows(updatedRows);
  };

  // Handle changing medical test row data
  const handleChangeMedicalTestRow = (index, field, value, isNew) => {
    const newRows = [...medicalTestRows];
    const updatedRow = { ...newRows[index], [field]: value };
    if (isNew !== undefined) {
      updatedRow.isNew = isNew;
    }
    newRows[index] = updatedRow;
    setMedicalTestRows(newRows);
  };

  //medical test option for medical filed
  const [medicalInput, setMedicalInput] = useState("");
  const handleMedicalChange = (inputValue) => {
    // e.preventDefault();
    setIsTyping(true);
    setMedicalInput(inputValue);
  };
  const debouncedInputMedicine = useDebounce(medicalInput, 1000);
  const { data: getAllMedicalTestData, isFetching: isLoading } = useQuery({
    queryKey: ["getMedicalTest", debouncedInputMedicine],
    queryFn: () =>
      getMedicalTest(user?.token, "null", 1, 10, debouncedInputMedicine),
    enabled: !!debouncedInputMedicine,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const medicalTestOptions =
    getAllMedicalTestData?.payload?.medical_tests || [];
  // Format options for react-select
  const formattedOptions = medicalTestOptions.map((test) => ({
    value: test.id,
    label: test.name,
  }));
    // lab options \\\]
    const { data: getAllLabs, isFetching:fetchLab } = useQuery({
      queryKey: ["getLabsList", "all"],
      queryFn: () => getLabsList(user?.token, "all", null, null),
      enabled: !!user?.token,
  
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnReconnect: false, // Don't refetch when reconnecting
    });
    const AllLabOptions = getAllLabs?.payload?.labs || [];
    const formattedLabOptions = AllLabOptions?.map((el) => ({
      value: el?.id,
      label: el?.name,
    }));
  const handleAddShortCode = async (e) => {
    e.preventDefault();

    if (!formState.name) {
      toast.error("Name is required");
      return;
    }

    // Validate that at least one medical test is added
    // if (medicalTestRows.length === 0) {
    //   toast.error("Please add at least one medical test");
    //   return;
    // }

    // Validate each row is properly filled
    for (let i = 0; i < medicalTestRows.length; i++) {
      const row = medicalTestRows[i];

      // Check if medical test is selected
      if (!row.medical_test_id) {
        toast.error(`Row ${i + 1}: Please select or create a medical test`);
        return;
      }

      // If it's a new test, check if lab is selected
      const isNewTest = typeof row.medical_test_id.value === "string";
      if (isNewTest && !row.lab) {
        toast.error(`Row ${i + 1}: Please select a lab for the new test`);
        return;
      }
    }

    // Process medical test rows
    const existingTestIds = [];
    const newMedicalTests = [];

    medicalTestRows.forEach((row) => {
      if (row.medical_test_id) {
        const testValue = row.medical_test_id.value;
        const testLabel = row.medical_test_id.label;
        const isNewTest = typeof testValue === "string";

        if (isNewTest) {
          const newTest = {
            name: testLabel,
            code: testValue.toUpperCase(),
          };
          // Add lab_id if lab is selected
          if (row.lab) {
            newTest.lab_id = row.lab.value;
          }
          newMedicalTests.push(newTest);
        } else {
          existingTestIds.push(testValue);
        }
      }
    });

    // Validate that at least one medical test is properly filled


    const payload = {
      medical_test_shortcode: {
        name: formState?.name,
        medical_test_ids: existingTestIds.map(id => String(id)),
      },
      new_medical_tests: newMedicalTests,
    };

    try {
      const data = await postShortCode(user?.token, payload);
      if (data.status.status === "SUCCESS") {
        toast.success("Medical Short Code Added Successfully");
        setFormState({});
        setMedicalTestRows([]);
        navigate("/admin/prescription/medical_test_shortcodes");
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };
  console.log(medicalTestRows, "CreatableSelect")
  useEffect(() => {
    if (isLoading) setIsTyping(false);
  }, [isLoading]);
  return (
    <>
      <Header />
      <Sidebar activeClassName="medical_test_shortcodes-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Shortcode Test</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Add Shortcode Test
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Add Shortcode Test</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Name <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.name}
                              name="name"
                              onChange={(e) =>
                                handleChange("name", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Add Medical Tests</h4>
                          </div>
                        </div>

                        {medicalTestRows?.length > 0 &&
                          medicalTestRows?.map((el, index) => (
                            <React.Fragment key={index}>
                              <div className="col-12 col-md-6 col-lg-6">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      marginRight: "8px",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    <p>{index + 1}</p>
                                  </div>
                                  <div
                                    className="form-group local-forms"
                                    style={{ flex: 1, width: "100%" }}
                                  >
                                      <label>
                                        Medical Test
                                        <span className="login-danger">*</span>
                                      </label>
                                      <CreatableSelect
                                        components={{
                                          DropdownIndicator: (props) => (
                                            <components.DropdownIndicator
                                              {...props}
                                            >
                                              <Search style={{ color: "#999" }} />
                                            </components.DropdownIndicator>
                                          ),
                                          IndicatorSeparator: () => null,
                                        }}
                                        isLoading={isLoading}
                                        options={formattedOptions}
                                        value={el.medical_test_id}
                                        onInputChange={handleMedicalChange}
                                        onChange={(selectedOption) => {
                                          const isNew =
                                            selectedOption?.__isNew__ || false;
                                          handleChangeMedicalTestRow(
                                            index,
                                            "medical_test_id",
                                            selectedOption,
                                            isNew
                                          );
                                        }}
                                        isValidNewOption={(inputValue) => {
                                          if (isLoading || isTyping)
                                            return false;
                                          if (!inputValue) return false;
                                          return true;
                                        }}
                                        formatCreateLabel={(inputValue) =>
                                          isLoading
                                            ? ""
                                            : `Create new test "${inputValue}"`
                                        }
                                        styles={{
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 999999,
                                          }),
                                          control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused
                                              ? "#007A99"
                                              : "rgba(46, 55, 164, 0.1)",
                                            boxShadow: state.isFocused
                                              ? "0 0 0 1px #007A99"
                                              : "none",
                                            "&:hover": {
                                              borderColor:
                                                "rgba(46, 55, 164, 0.1)",
                                            },
                                            borderRadius: "10px",
                                            fontSize: "14px",
                                            minHeight: "45px",
                                          }),
                                          dropdownIndicator: (base, state) => ({
                                            ...base,
                                            transform: state.selectProps
                                              .menuIsOpen
                                              ? "rotate(-180deg)"
                                              : "rotate(0)",
                                            transition: "250ms",
                                            width: "35px",
                                            height: "35px",
                                          }),
                                        }}
                                        isSearchable
                                        isClearable
                                        placeholder="Choose medical test"
                                        className="react-select"
                                        classNamePrefix="select"
                                      />
                                    </div>
                                  </div>
                                </div>
                              {el?.isNew && (
                                <div className="col-12 col-md-5 col-lg-5">
                                  <div className="form-group local-forms">
                                    <label>
                                      Lab
                                      <span className="login-danger">*</span>
                                    </label>
                                    <Select
                                      options={formattedLabOptions}
                                      value={el.lab}
                                      onChange={(selectedOption) => {
                                        handleChangeMedicalTestRow(
                                          index,
                                          "lab",
                                          selectedOption
                                        );
                                      }}
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 999999,
                                        }),
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          borderColor: state.isFocused
                                            ? "#007A99"
                                            : "rgba(46, 55, 164, 0.1)",
                                          boxShadow: state.isFocused
                                            ? "0 0 0 1px #007A99"
                                            : "none",
                                          "&:hover": {
                                            borderColor:
                                              "rgba(46, 55, 164, 0.1)",
                                          },
                                          borderRadius: "10px",
                                          fontSize: "14px",
                                          minHeight: "45px",
                                        }),
                                        dropdownIndicator: (base, state) => ({
                                          ...base,
                                          transform: state.selectProps
                                            .menuIsOpen
                                            ? "rotate(-180deg)"
                                            : "rotate(0)",
                                          transition: "250ms",
                                          width: "35px",
                                          height: "35px",
                                        }),
                                      }}
                                      isSearchable
                                      isClearable
                                      placeholder="Choose lab"
                                      className="react-select"
                                      classNamePrefix="select"
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="col-12 col-md-1 col-lg-1">
                                <button
                                  style={{
                                    maxWidth: "150px",
                                    height: "45px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    
                                  }}
                                  onClick={(e) =>
                                    handleRemoveMedicalTestRow(e, index)
                                  }
                                  className="btn btn-primary submit-form form-control mb-4"
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                            </React.Fragment>
                          ))}

                        <div className="col-12 col-md-12 col-xl-12">
                          <button
                            style={{ width: "20%" }}
                            className="btn btn-primary submit-form me-2 form-control mb-4"
                            onClick={handleAddMedicalTestRow}
                          >
                            Add New Item
                          </button>
                        </div>

                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleAddShortCode}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(
                                  "/admin/prescription/medical_test_shortcodes"
                                );
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="notification-box">
            <div className="msg-sidebar notifications msg-noti">
              <div className="topnav-dropdown-header">
                <span>Messages</span>
              </div>
              <div className="drop-scroll msg-list-scroll" id="msg_list">
                <ul className="list-box">
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Richard Miles </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item new-message">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">John Doe</span>
                          <span className="message-time">1 Aug</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Tarah Shropshire{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Mike Litorus</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Catherine Manseau{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">D</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Domenic Houston{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">B</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Buster Wigton{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Rolland Webber{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Claire Mapes </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Melita Faucher</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Jeffery Lalor</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">L</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Loren Gatlin</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            Tarah Shropshire
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="#">See all messages</Link>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AddShortCode;
